import { AutoMap } from "@automapper/classes";
import { ClientDTO } from "./client.dto";

export class UserDTO {
    @AutoMap()
    email: string = '';

    @AutoMap()
    firstName: string = '';
    @AutoMap()
    lastName: string = '';
    @AutoMap()
    eIMASGuid: string = '';
    @AutoMap()
    isActive: boolean = true;
    //#region EIMAS
    @AutoMap()
    pI_SRI: string = '';
    //#endregion
    @AutoMap()
    type?: number;
    @AutoMap(() => ClientDTO)
    clientList: ClientDTO[] = [];
}